<div class="am-content">
  <div class="main-content">
    <div class="page-head">
      <h2 class="title">Geothermal</h2>
      <ol class="breadcrumb">
        <li>
          <a [routerLink]="NAVIGATIONS.HOME.route">{{
            NAVIGATIONS.HOME.name
          }}</a>
        </li>
        <li class="active">{{ NAVIGATIONS.GEOTHERMAL.name }}</li>
      </ol>
    </div>
    <div>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div
              [ngStyle]="{ border: !isPreSimulationFormValid ? 'none' : '' }"
              class="panel-heading"
            >
              <div id="simulationSelectorPanel">
                <div id="simulationPanel">
                  <div *ngIf="simulationName == ''">
                    Simulation
                  </div>
                  <div *ngIf="simulationName != ''">
                    <strong>{{ simulationName }}</strong>
                  </div>
                </div>
                <div>
                  <div>
                    <div id="unitSystemPanel" class="form-group">
                      <label id="unitSystemLabel">Unit System</label>
                      <div class="am-radio inline">
                        <input
                          id="rdMetric"
                          type="radio"
                          name="radioOption"
                          class="input-xs"
                          [value]="UnitSystem.SI"
                          [checked]="unitSystem === UnitSystem.SI"
                          (change)="onUnitSystemChange(UnitSystem.SI)"
                        />
                        <label for="rdMetric" class="input-xs">Metric</label>
                      </div>
                      <div class="am-radio inline">
                        <input
                          id="rdImperial"
                          type="radio"
                          name="radioOption"
                          class="input-xs"
                          [value]="UnitSystem.USC"
                          [checked]="unitSystem === UnitSystem.USC"
                          (change)="onUnitSystemChange(UnitSystem.USC)"
                        />
                        <label for="rdImperial" class="input-xs"
                          >Imperial</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <app-pre-simulation #preSimulation></app-pre-simulation>
            </div>
            <div
              [ngStyle]="{ display: !isPreSimulationFormValid ? 'none' : '' }"
              class="range-container"
            >
              <div class="col-md-6">
                Complete the following fields: Model Validity
                <span id="rangeModal" (click)="showRangeModal()"
                  ><b>Ranges</b></span
                >
              </div>
              <div class="col-md-6">
                <p>
                  Check existance on
                  <a href="https://dcp.tenaris.com/" target="_blank"
                    >Tenaris Premium Connections Performance Datasheets
                  </a>
                </p>
              </div>
            </div>
            <div
              [ngStyle]="{ display: !isPreSimulationFormValid ? 'none' : '' }"
              class="panel-body"
            >
              <form [formGroup]="fgGeothermal" (ngSubmit)="onSubmit()" #geoFormElem>
                <div class="row">
                  <div class="col-md-6">
                    <!-- General Information -->
                    <div class="panel-default">
                      <div class="geothermal-panel widget-head">
                        <h3>General Information</h3>
                      </div>
                    </div>
                    <div class="row panel-body">
                      <div class="row">
                        <div class="col-md-6">
                          <label class="input-xs"
                            >Modulus of elasticity, E</label
                          >
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                id="modulusE"
                                class="form-control input-xs no-spin"
                                formControlName="modulusE"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'modulusEError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "psi" : "MPa"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="modulusEError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-6">
                          <label class="input-xs">Poisson’s Ratio, v</label>
                          <div class="xs-mb-15">
                            <input
                              id="poisson"
                              formControlName="poisson"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'poissonError'"
                              autocomplete="off"
                            />
                          </div>
                          <error-message
                            id="poissonError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="input-xs"
                            >Coeff. of thermal Exp. β</label
                          >
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                id="thermalExp"
                                formControlName="thermalExp"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'thermalExpError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "1/°F" : "1/°C"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="thermalExpError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-6">
                          <label class="input-xs">Friction Factor</label>
                          <div class="xs-mb-15">
                            <input
                              id="friction"
                              formControlName="friction"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'frictionError'"
                              autocomplete="off"
                            />
                          </div>
                          <error-message
                            id="frictionError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div
                            class="am-checkbox input-xs"
                            style="margin-bottom: 8px"
                          >
                            <input
                              id="calcEccentricity"
                              type="checkbox"
                              formControlName="calcEccentricity"
                            />
                            <label id="eccentricityLabel" for="calcEccentricity"
                              >Eccentricity</label
                            >
                          </div>
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                id="eccentricity"
                                formControlName="eccentricity"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'eccentricityError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                              >
                                {{ unitSystem === "USC" ? "in" : "mm" }}
                              </span>
                            </div>
                          </div>
                          <error-message
                            id="eccentricityError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-6">
                          <label class="input-xs">Direction of Motion</label>
                          <div class="xs-mb-15">
                            <ng-select
                              id="directionMotion"
                              formControlName="directionMotion"
                              class="geothermal-ng-select"
                              [items]="directionMotionOptions"
                              bindLabel="label"
                              bindValue="value"
                              [clearable]="false"
                              [searchable]="false"
                              placeholder="Select"
                              errorMessage
                              [errorContainerId]="'directionMotionError'"
                            >
                            </ng-select>
                          </div>
                          <error-message
                            id="directionMotionError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <!-- Casing Specification -->
                    <div class="panel-default">
                      <div
                        class="geothermal-panel widget-head"
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                        "
                      >
                        <h3>Casing Specification</h3>
                        <div style="font-size: 25px; cursor: pointer">
                          <span
                            class="s7-search"
                            data-toggle="modal"
                            data-target="#dcpModal"
                            data-placement="right"
                            data-tooltip
                            title="Search Pipes"
                            (click)="loadModal()"
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div class="row panel-body">
                      <app-slotted-modal></app-slotted-modal>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="input-xs">Outside Diameter (OD)</label>
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                #outsideDiameterInput
                                formControlName="outsideDiameter"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'outsideDiameterError'"
                                autocomplete="off"
                                [readonly]="isUser"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{ unitSystem === "USC" ? "in" : "mm" }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="outsideDiameterError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-6">
                          <label class="input-xs">Nominal Weight</label>
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="nominalWeight"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'nominalWeightError'"
                                autocomplete="off"
                                [readonly]="isUser"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "lb/ft" : "kg/m"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="nominalWeightError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="input-xs">Wall Thickness</label>
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="wallThickness"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'wallThicknessError'"
                                autocomplete="off"
                                [readonly]="isUser"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{ unitSystem === "USC" ? "in" : "mm" }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="wallThicknessError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-6">
                          <label class="input-xs">Inside Diameter (ID)</label>
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="insideDiameter"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'insideDiameterError'"
                                autocomplete="off"
                                [readonly]="isUser"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{ unitSystem === "USC" ? "in" : "mm" }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="insideDiameterError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="input-xs">Grade</label>
                          <div class="xs-mb-15">
                            <input
                              formControlName="grade"
                              class="form-control input-xs no-spin"
                              errorMessage
                              [errorContainerId]="'gradeError'"
                              autocomplete="off"
                              [readonly]="isUser"
                            />
                          </div>
                          <error-message
                            id="gradeError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-6">
                          <label class="input-xs">SMYS</label>
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="smys"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'smysError'"
                                autocomplete="off"
                                [readonly]="isUser"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "psi" : "MPa"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="smysError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="input-xs">Temp. Derating</label>
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="tempDerating"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'tempDeratingError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "%/°F" : "%/°C"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="tempDeratingError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-6">
                          <label class="input-xs">Holliday Limit</label>
                          <div class="xs-mb-15">
                            <input
                              formControlName="hollLimit"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'hollLimitError'"
                              autocomplete="off"
                            />
                          </div>
                          <error-message
                            id="hollLimitError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <!-- Load Information (Initial and Final Conditions) -->
                    <div class="panel-default">
                      <div class="geothermal-panel widget-head">
                        <h3>Load Information (Initial and Final Conditions)</h3>
                      </div>
                    </div>
                    <div class="row panel-body">
                      <!-- Header row for Initial/Final -->
                      <div class="col-md-4"></div>
                      <div class="col-md-4 text-center">
                        <strong>Initial</strong>
                      </div>
                      <div class="col-md-4 text-center">
                        <strong>Final</strong>
                      </div>
                      <!-- Inside Density -->
                      <div class="row p-0 m-0">
                        <div class="col-md-4 d-flex align-items-center">
                          <label class="input-xs">Inside Density</label>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="insideDensityInitial"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'insideDensityInitialError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "ppg" : "kg/m³"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="insideDensityInitialError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="insideDensityFinal"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'insideDensityFinalError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "ppg" : "kg/m³"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="insideDensityFinalError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                      <!-- Outside Density -->
                      <div class="row p-0 m-0">
                        <div class="col-md-4 d-flex align-items-center">
                          <label class="input-xs">Outside Density</label>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="outsideDensityInitial"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="
                                  'outsideDensityInitialError'
                                "
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "ppg" : "kg/m³"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="outsideDensityInitialError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="outsideDensityFinal"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'outsideDensityFinalError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "ppg" : "kg/m³"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="outsideDensityFinalError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                      <!-- Inside Pressure -->
                      <div class="row p-0 m-0">
                        <div class="col-md-4 d-flex align-items-center">
                          <label class="input-xs">Inside Pressure</label>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="insidePressureInitial"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="
                                  'insidePressureInitialError'
                                "
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "psi" : "MPa"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="insidePressureInitialError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="insidePressureFinal"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'insidePressureFinalError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "psi" : "MPa"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="insidePressureFinalError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                      <!-- Outside Pressure -->
                      <div class="row p-0 m-0">
                        <div class="col-md-4 d-flex align-items-center">
                          <label class="input-xs">Outside Pressure</label>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="outsidePressureInitial"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="
                                  'outsidePressureInitialError'
                                "
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "psi" : "MPa"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="outsidePressureInitialError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="outsidePressureFinal"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'outsidePressureFinalError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{
                                  unitSystem === "USC" ? "psi" : "MPa"
                                }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="outsidePressureFinalError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                      <!-- Avg Temperature -->
                      <div class="row p-0 m-0">
                        <div class="col-md-4 d-flex align-items-center">
                          <label class="input-xs">Avg. Temperature</label>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="avgTemperatureInitial"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="
                                  'avgTemperatureInitialError'
                                "
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{ unitSystem === "USC" ? "°F" : "°C" }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="avgTemperatureInitialError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                        <div class="col-md-4">
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="avgTemperatureFinal"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'avgTemperatureFinalError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{ unitSystem === "USC" ? "°F" : "°C" }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="avgTemperatureFinalError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="col-md-12 p-0">
                      <!-- Hole Dimension -->
                      <div class="panel-default">
                        <div class="geothermal-panel widget-head">
                          <h3>Hole Dimension</h3>
                        </div>
                      </div>
                      <div class="row panel-body">
                        <div class="col-md-6">
                          <label class="input-xs">Hole ID</label>
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="holeId"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'holeIdError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{ unitSystem === "USC" ? "in" : "mm" }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="holeIdError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 p-0">
                      <!-- Displacement due to Pre-load -->
                      <div class="panel-default">
                        <div class="geothermal-panel widget-head">
                          <h3>Displacement due to Pre-load</h3>
                        </div>
                      </div>
                      <div class="row panel-body">
                        <div class="col-md-6">
                          <label class="input-xs">Δ L Pre-load</label>
                          <div class="xs-mb-15">
                            <div class="input-group">
                              <input
                                formControlName="deltaLPreload"
                                class="form-control input-xs no-spin"
                                commaToDot
                                errorMessage
                                [errorContainerId]="'deltaLPreloadError'"
                                autocomplete="off"
                              />
                              <span
                                class="input-group-addon input-xs label-dts thickness-0"
                                >{{ unitSystem === "USC" ? "ft" : "m" }}</span
                              >
                            </div>
                          </div>
                          <error-message
                            id="deltaLPreloadError"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <!-- Temp. °F -->
                    <div class="col-md-12 p-0">
                      <div class="panel-default">
                        <div class="geothermal-panel widget-head">
                          <h3>
                            Temperature
                            {{ unitSystem === UnitSystem.USC ? "°F" : "°C" }}
                          </h3>
                        </div>
                      </div>
                      <div class="row panel-body">
                        <div class="col-md-2" *ngFor="let t of [1, 2, 3, 4, 5]">
                          <label class="input-xs">T{{ t }}</label>
                          <div class="xs-mb-15">
                            <input
                              [formControlName]="'tempT' + t"
                              class="form-control input-xs no-spin"
                              commaToDot
                              errorMessage
                              [errorContainerId]="'tempTerror' + t"
                              autocomplete="off"
                            />
                          </div>
                          <error-message
                            id="tempTerror{{ t }}"
                            class="text-danger"
                            style="top: -15px; position: relative"
                          ></error-message>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="col-md-12 p-0">
                      <!-- Simulation Settings -->
                      <div class="panel-default">
                        <div class="geothermal-panel widget-head">
                          <h3>Simulation Settings</h3>
                        </div>
                      </div>
                      <div class="row panel-body">
                        <div class="col-md-6">
                          <div class="am-checkbox simulation-settings-checkbox">
                            <input
                              id="thermoCollapse"
                              type="checkbox"
                              formControlName="thermoCollapse"
                            />
                            <label for="thermoCollapse">Thermal Collapse</label>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="am-checkbox simulation-settings-checkbox">
                            <input
                              id="unsuppBkl"
                              type="checkbox"
                              formControlName="unsuppBkl"
                            />
                            <label for="unsuppBkl">Unsupported Buckling</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <!-- LUS Coeff. -->
                    <div class="panel-default">
                      <div class="geothermal-panel widget-head">
                        <h3>Unsupported Length Coefficients</h3>
                      </div>
                    </div>
                    <div class="row panel-body">
                      <div class="col-md-1" *ngFor="let i of lusCoeffLabels">
                        <label class="input-xs">L{{ i }}</label>
                        <div class="xs-mb-15">
                          <input
                            [formControlName]="'lusCoeffL' + i"
                            class="form-control input-xs no-spin"
                            commaToDot
                            errorMessage
                            [errorContainerId]="'lusCoeffLError' + i"
                            autocomplete="off"
                            [readonly]="isUser || i == 1"
                          />
                        </div>
                        <error-message
                          id="lusCoeffLError{{ i }}"
                          class="text-danger"
                          style="top: -15px; position: relative"
                        ></error-message>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row row-styles">
                  <div class="col-md-12" style="text-align: right">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      [disabled]="fgGeothermal.invalid"
                    >
                      Submit
                    </button>
                    
                  </div>
                </div>
              </form>
              <app-geothermal-results
                *ngIf="shouldShowResults"
                [thermalCollapseResponses]="showThermalCollapseResults ? geothermalResults.thermalCollapseResponses : []"
                [unsupportedLengthResponses]="showUnsupportedBucklingResults ? geothermalResults.unsupportedLengthResponses : {}"
              ></app-geothermal-results>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal de rangos geothermal -->
  <app-geothermal-ranges-modal
    [show]="isRangeModalOpen"
    (close)="closeRangeModal()"
  ></app-geothermal-ranges-modal>
</div>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>
